/* Noxrivet reference homepage: card swatches and newsletter form states. */
(() => {
  if (window.nxhInit) return;
  window.nxhInit = true;

  // Product card swatches: swap the card image, links and price to the chosen color's variant.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.nxh-swatch-btn');
    if (!button) return;
    const card = button.closest('[data-nxh-card]');
    if (!card) return;

    card.querySelectorAll('.nxh-swatch-btn').forEach((b) => b.setAttribute('aria-pressed', String(b === button)));

    const img = card.querySelector('.nxh-card__img');
    if (img && button.dataset.src) {
      img.srcset = button.dataset.srcset || '';
      img.src = button.dataset.src;
    }
    if (button.dataset.url) {
      card.querySelectorAll('[data-nxh-link]').forEach((a) => {
        a.href = button.dataset.url;
      });
    }
    const price = card.querySelector('[data-nxh-price]');
    if (price && button.dataset.price) price.textContent = button.dataset.price;
    const colorName = card.querySelector('[data-nxh-color]');
    if (colorName && button.dataset.name) colorName.textContent = button.dataset.name;
  });

  // Newsletter: validate before posting to Shopify, show a sending state, report the result.
  const EMAIL = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[^\s@.]{2,}$/;

  // Shopify's storefront bot protection may pause the post for a captcha check, so the
  // sending state clears itself and never blocks a retry.
  const resetButton = (form) => {
    const button = form.querySelector('button[type="submit"]');
    const message = form.querySelector('[data-nxh-msg]');
    clearTimeout(form.nxhTimer);
    if (!button || button.getAttribute('aria-busy') !== 'true') return;
    button.removeAttribute('aria-busy');
    button.textContent = button.dataset.label || button.textContent;
    if (message && message.textContent === button.dataset.loading) message.textContent = '';
  };

  document.querySelectorAll('form[data-nxh-news]').forEach((form) => {
    const input = form.querySelector('input[type="email"]');
    const message = form.querySelector('[data-nxh-msg]');
    const button = form.querySelector('button[type="submit"]');
    if (!input || !message || !button) return;

    const showError = (text) => {
      input.setAttribute('aria-invalid', 'true');
      message.setAttribute('role', 'alert');
      message.textContent = text;
      input.focus();
    };

    form.addEventListener('submit', (event) => {
      const value = input.value.trim();
      input.value = value;
      if (!value) {
        event.preventDefault();
        showError(form.dataset.empty || 'Enter your email address.');
        return;
      }
      if (!EMAIL.test(value)) {
        event.preventDefault();
        showError(form.dataset.invalid || 'Enter a valid email address.');
        return;
      }
      input.removeAttribute('aria-invalid');
      message.removeAttribute('role');
      message.setAttribute('aria-live', 'polite');
      message.textContent = button.dataset.loading || '';
      button.setAttribute('aria-busy', 'true');
      button.textContent = button.dataset.loading || button.textContent;
      clearTimeout(form.nxhTimer);
      form.nxhTimer = setTimeout(() => resetButton(form), 8000);
    });

    input.addEventListener('input', () => {
      if (input.getAttribute('aria-invalid') === 'true' && EMAIL.test(input.value.trim())) {
        input.removeAttribute('aria-invalid');
        message.textContent = '';
      }
    });

    // After Shopify redirects back, move focus to the confirmed result.
    const result = form.querySelector('[data-nxh-result]');
    if (result) {
      requestAnimationFrame(() => result.focus({ preventScroll: false }));
    }
  });

  // Header help disclosure (snippets/nx-utility-links): close on Escape or an outside click/tap.
  const closeDiscs = (except) => {
    document.querySelectorAll('details[data-nx-disc][open]').forEach((d) => {
      if (d !== except) d.removeAttribute('open');
    });
  };
  document.addEventListener('click', (event) => closeDiscs(event.target.closest('details[data-nx-disc]')));
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector('details[data-nx-disc][open]');
    if (!open) return;
    open.removeAttribute('open');
    open.querySelector('summary')?.focus();
  });
  document.addEventListener('focusin', (event) => closeDiscs(event.target.closest('details[data-nx-disc]')));

  // Restore the button if the page comes back from the back/forward cache.
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) document.querySelectorAll('form[data-nxh-news]').forEach(resetButton);
  });
})();
